import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {host} from '../../function/api'

export const fetchDocumentStatus = createAsyncThunk(
    'document/status/index',
    async(token, thunkAPI) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${host}statusDocument`,
                headers: {
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${token}`
                }
            })

            return await response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error)
        }
    }
)
export const userDocumentStatus = createAsyncThunk(
    'document/status/user',
    async(token, thunkAPI) => {
        try {
            const response = await axios({
                method: 'GET',
                url: `${host}status/document/user`,
                headers: {
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${token}`
                }
            })

            return await response.data;

        } catch (error) {
            return thunkAPI.rejectWithValue(error)
        }
    }
)
export const documentStatusStore = createAsyncThunk(
    'document/status/store',
    async(data, thunkApi) => {
        try {
            const response = await axios({
                methood: 'POST',
                url: `${host}documentStatus`,
                data: data,
                headers: {
                        'Accept': 'Application/json',
                        'xsrfHeaderName': "X-XSRF-TOKEN",
                        'withCredentials': true,
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }        
                })

            return await response.data;

        } catch (error) {
            return thunkApi.rejectWithValue(error);
        }
    }
)

const initialState = {
    loading: false,
    success: false,
    error: [],
    statuses: [],
}
const documentStatusSlice = createSlice({
    name: 'position',
    initialState,
    reducers:{

    },
    extraReducers: {
        [documentStatusStore.fulfilled]: (state, {payload}) => {  
            state.loading = false
            state.success = true
            state.message = payload.message
            state.errorTitle = ""
        },
        [documentStatusStore.pending] : (state) => {
            state.loading = true    
            state.success = false
        },
        [documentStatusStore.rejected]: (state, {payload}) => {
            state.loading = false
            state.success = false
            if(payload.response.data.error) {
                state.errorTitle = payload.response.data.error.title
            }else if(payload.response.data.message) {
                state.message = payload.response.data.message
            }
            
        },
        [fetchDocumentStatus.fulfilled]: (state, action) => {
            state.loading = false;
            state.statuses = action.payload.data
        },
        [fetchDocumentStatus.pending]: (state) => {
            state.loading = true;
        },
        [fetchDocumentStatus.rejected]: (state, { payload }) => {
            state.loading = false;
            state.success = false;
            if(payload.response.data.error){
                state.error = payload.response.data.error
            } else if (payload.response.data.message) {
                state.message = payload.response.data.message
            }
        },
        [userDocumentStatus.fulfilled]: (state, action) => {
            state.loading = false;
            state.statuses = action.payload.data
        },
        [userDocumentStatus.pending]: (state) => {
            state.loading = true;
        },
        [userDocumentStatus.rejected]: (state, { payload }) => {
            state.loading = false;
            state.success = false;
            if(payload.response.data.error){
                state.error = payload.response.data.error
            } else if (payload.response.data.message) {
                state.message = payload.response.data.message
            }
        }
    }
})

export const {} = documentStatusSlice.actions;
export default documentStatusSlice.reducer;